/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 6/24/19
 * Time: 2:01 PM
 */

import axios from 'axios';
import * as axiosPublic from './axios_public_urls';

const instance=axios.create({
    baseURL:axiosPublic.EVENTTAG_URL
});

export default instance;
